import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import "./App.css";
import Login from "./components/Login/Login.js";
import Loading from "./components/Loading/Loading.js";
import useMyStore from "./Global.js";
import Home from "./screens/Home.js";
import { Route, Routes } from "react-router";
import { API } from "./assets/staticData.js";

const App = () => {
  const [loading, setLoading] = useState(true);
  const userLoggedIn = useMyStore((state) => state.userLoggedIn);
  const setUserLoggedIn = useMyStore((state) => state.setUserLoggedIn);
  const setUser = useMyStore((state) => state.setUser);

  // Theme Settings
  const theme = createTheme({
    typography: {
      fontFamily: "Poppins",
    },
    palette: {
      secondary: {
        main: "#00166a",
      },
    },
  });

  // // Retrieves website settings from the server
  // useEffect(() => {
  //   async function getData() {
  //     fetch("http://localhost:1337/api/general-settings", {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     })
  //       .then(async (res) => {
  //         const respone = await res.json();
  //         document.title = respone.data.attributes.websiteTitle;
  //         console.log(respone);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }

  //   getData();
  // }, []);

  // Checks if the user is logged in or not
  useEffect(() => {
    let userToken = localStorage.getItem("userToken");
    async function chechUser() {
      fetch(`${API}/users/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })
        .then(async (res) => {
          const respone = await res.json();
          if (respone?.id) {
            setLoading(false);
            setUserLoggedIn(true);
            setUser(respone)
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (userToken) {
      chechUser();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/" element={userLoggedIn ? <Home /> : <Login />} />
        {/* <Route path="/" element={<Home />} /> */}
      </Routes>

      {loading && <Loading />}
      <ToastContainer />
    </ThemeProvider>
  );
};

export default App;
